import { render } from "./JobCreateSkillsDropdown.vue?vue&type=template&id=00bf3f90"
import script from "./JobCreateSkillsDropdown.vue?vue&type=script&lang=js"
export * from "./JobCreateSkillsDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__